export const getAdornments = (adornments = [], field = {}) =>
  adornments.filter((adornment) => {
    return adornment.field_type === field.fieldType;
  });
